import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-6-preview.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')